"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatValue = function (value) {
    return typeof value === "string" && value.includes(" ") ? "\"".concat(value, "\"") : value;
};
var Filter = /** @class */ (function () {
    function Filter(column, value, operator, type) {
        if (operator === void 0) { operator = "="; }
        if (type === void 0) { type = "AND"; }
        this.column = column;
        this.operator = operator;
        this.type = type;
        this.value = value;
    }
    Filter.prototype.format = function (index) {
        return "".concat(index === 0 ? "" : "".concat(this.type, " ")).concat(this.column, " ").concat(this.operator, " ").concat(formatValue(this.value));
    };
    return Filter;
}());
exports.default = Filter;
